"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const oidc_1 = __importDefault(require("../../vanilla/oidc"));
const route_utils_1 = require("../../vanilla/route-utils");
const SilentLogin = (({ configurationName }) => {
    const queryParams = (0, route_utils_1.getParseQueryStringFromLocation)(window.location.href);
    const getOidc = oidc_1.default.get;
    const oidc = getOidc(configurationName);
    let extras = null;
    for (let [key, value] of Object.entries(queryParams)) {
        if (key === "state" || key == "scope") {
            continue;
        }
        if (extras === null) {
            extras = {};
        }
        extras[key] = value;
    }
    (0, react_1.useEffect)(() => {
        if (!oidc.tokens) {
            oidc.loginAsync(null, extras, true, queryParams.scope);
        }
        return () => {
        };
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null);
});
exports.default = SilentLogin;
//# sourceMappingURL=SilentLogin.component.js.map